<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
<template>
    <v-card flat>
        <v-container fluid>                        
            <!-- <v-row dense>
                <v-col>
                    <v-text-field 
                        v-model="notification.title" 
                        clearable 
                        label="タイトル" 
                        outlined 
                        type="text" 
                        counter="20" />
                </v-col>
                <v-col>
                    <v-text-field 
                        v-model="notification.title" 
                        clearable 
                        label="タイトル" 
                        outlined 
                        type="text" 
                        counter="20" />
                </v-col>
            </v-row> -->
            <v-row dense>
                <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
                    <v-data-table 
                        dense
                        :items-per-page="15"
                        :headers="areaHeader"
                        :items="areas"
                        @click:row="onClickArea">
                        <template v-slot:item.isCollectWeather="{ item }">
                            <v-icon v-if="item.isCollectWeather" small>mdi-check</v-icon>
                            <v-icon v-else small>mdi-close</v-icon>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <v-btn icon small @click.stop="onClickDeleteArea(item)">
                                <v-icon>mdi-delete-circle-outline</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
                    <v-card outlined>
                        <v-container fluid>
                            <v-row>
                                <v-col>
                                    <v-text-field 
                                        v-model="editItems.area"
                                        dense
                                        clearable 
                                        label="地域ID" 
                                        outlined 
                                        type="text"
                                        hide-details />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field 
                                        v-model="editItems.pref" 
                                        dense
                                        clearable 
                                        label="都道府県名" 
                                        outlined 
                                        type="text"
                                        hide-details />
                                </v-col>
                                <v-col>
                                    <v-text-field 
                                        v-model="editItems.city" 
                                        dense
                                        clearable 
                                        label="市名" 
                                        outlined 
                                        type="text"
                                        hide-details />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col>
                                    <v-checkbox
                                        v-model="editItems.isCollectWeather" 
                                        dense
                                        label="気象データ収集" 
                                        outlined 
                                        type="text"
                                        hide-details />
                                </v-col>
                            </v-row>
                        </v-container>
                        <v-card-actions>
                            <v-btn color="primary" @click="onClickUpdateArea">更新</v-btn>
                        </v-card-actions>
                    </v-card>
                    <span class="caption">ここで登録した内容は天気取得サービスには反映されません。<br/>天気取得サービスの管理から別途作業する必要があります。</span>
                </v-col>
            </v-row>
        </v-container>
        <!-- <v-card-actions>
            <v-btn color="primary" @click="onClickSendNotification">通知する</v-btn>
        </v-card-actions> -->
    </v-card>
</template>

<script>
    import db from '@/firebase/firestore.js'
    export default {
        data: function () {
            return {
                areas: [],
                areaHeader: [
                    {
                        text: "地域ID",
                        align: "start",
                        sortable: true,
                        value: "area"
                    },
                    {
                        text: "県",
                        align: "start",
                        sortable: true,
                        value: "pref"
                    },
                    {
                        text: "市",
                        align: "start",
                        sortable: true,
                        value: "city",
                    },
                    {
                        text: "気象データ収集",
                        align: "center",
                        sortable: true,
                        value: "isCollectWeather"
                    },
                    {
                        text: "",
                        align: "middle",
                        sortable: true,
                        value: "action"
                    },
                ],
                editItems: {
                    area: "",
                    pref: "",
                    city: "",
                    isCollectWeather: false
                },
            }
        },
        mounted: function () {
            const self = this
            this.areas = []
            db.collection("areas").orderBy("area").get().then(function(snapShot){
                snapShot.forEach(function(doc){
                    const area = doc.data()
                    self.areas.push(area)
                })
            })
        },
        methods: {
            onClickArea: function (area) {
                this.editItems.area = area.area
                this.editItems.pref = area.pref
                this.editItems.city = area.city
                this.editItems.isCollectWeather = area.isCollectWeather
            },
            onClickDeleteArea: function (area) {
                const self = this
                db.collection("areas").doc(area.area+"").delete().then(function(){
                    const index = self.areas.findIndex((v)=>v.area == area.area)
                    if (index < 0) {
                    } else {
                        self.areas.splice(index, 1)
                    }
                })
            },
            onClickUpdateArea: function () {
                const self = this
                const area = {
                    area: this.editItems.area,
                    pref: this.editItems.pref,
                    city: this.editItems.city,
                    isCollectWeather: this.editItems.isCollectWeather,
                }
                console.log(area)
                db.collection("areas").doc(area.area+"").set(area).then(function(){
                    const index = self.areas.findIndex((v)=>v.area == area.area)
                    if (index < 0) {
                        self.areas.push(area)
                    } else {
                        self.areas.splice(index, 1)
                        self.areas.splice(index, 0, area)
                    }
                })
            },
        }
    }
</script>
